export const translations = {
    en: {
        home: {
            hero: {
                badge: 'Serving the Neighborhood for Many Years',
                title: 'Your Local',
                titleHighlight: 'Pharmacy',
                subtitle: 'Fast, friendly, and reliable service. Free home delivery, expert medication counseling, and personalized care for our community in Jamaica, NY.',
                ctaContact: 'Contact Us',
                ctaServices: 'Our Services'
            },
            trustBar: {
                prescriptionTime: '10-15 min',
                prescriptionLabel: 'Prescription Ready',
                deliveryLabel: 'Free',
                deliverySubLabel: 'Home Delivery',
                staffLabel: 'Multilingual',
                staffSubLabel: 'Staff Available',
                insuranceLabel: 'Most',
                insuranceSubLabel: 'Insurance Accepted'
            },
            services: {
                title: 'Our Services',
                subtitle: 'Comprehensive pharmacy services designed to keep you healthy and well.',
                viewAll: 'View all services',
                cards: [
                    {
                        title: 'Prescriptions',
                        body: 'Fast prescription filling, hassle-free transfers, medication synchronization, and automatic refill reminders.',
                        learnMore: 'Learn more'
                    },
                    {
                        title: 'Immunizations',
                        body: 'Flu, COVID-19, RSV, Shingles, Pneumonia vaccines and more. Walk-ins welcome or schedule an appointment.',
                        learnMore: 'Learn more'
                    },
                    {
                        title: 'Clinical Services',
                        body: 'Blood pressure checks, diabetes counseling, glucose monitoring, free medication consultations.',
                        learnMore: 'Learn more'
                    },
                    {
                        title: 'Specialty Services',
                        body: 'DME supplies, workers\' compensation support, blister packaging, and special medication orders.',
                        learnMore: 'Learn more'
                    }
                ]
            },
            whyChoose: {
                title: 'Why Choose Hillside Dhaka Pharmacy',
                subtitle: "We're more than just a pharmacy — we're your healthcare partner in the community.",
                features: [
                    {
                        title: 'Free Home Delivery',
                        description: 'Get your prescriptions delivered to your door at no extra cost. Every day delivery service available.'
                    },
                    {
                        title: 'Fast Service',
                        description: 'Most prescriptions ready in 10-15 minutes. Walk-ins welcome, no appointment necessary.'
                    },
                    {
                        title: 'Multilingual Staff',
                        description: 'Our team speaks English and Bengali to better serve our diverse community.'
                    },
                    {
                        title: 'Competitive Prices',
                        description: 'Competitive cash pricing and discount programs. We accept Medicaid, Medicare, and most insurances.'
                    },
                    {
                        title: 'Expert Counseling',
                        description: 'Licensed pharmacists available for free medication consultations and OTC recommendations.'
                    },
                    {
                        title: 'Community Focused',
                        description: 'Family-owned pharmacy serving the Bengali neighborhood for many years with personalized care.'
                    }
                ]
            },
            cta: {
                title: 'Visit Us Today',
                getDirections: 'Get Directions',
                contactUs: 'Contact Us'
            }
        },
        about: {
            hero: {
                title: 'About',
                titleHighlight: 'Us',
                subtitle: 'Your trusted neighborhood pharmacy, serving the Jamaica community with care and dedication'
            },
            story: {
                title: 'Our Story',
                paragraphs: [
                    'Hillside Dhaka Pharmacy has been proudly serving the Jamaica, NY community for many years. Located at 17014 Hillside Ave, we are your local, family-owned pharmacy dedicated to providing exceptional pharmaceutical care and personalized service.',
                    'As a community pharmacy in the heart of the Bengali neighborhood, we understand the unique healthcare needs of our diverse community. Our multilingual staff is here to assist you in English and Bengali, ensuring clear communication and understanding of your healthcare needs.',
                    'We believe in building lasting relationships with our customers. When you walk through our doors, you\'re not just a prescription number—you\'re a valued member of our pharmacy family.'
                ]
            },
            values: {
                title: 'Our Values',
                subtitle: 'What drives us every day',
                items: [
                    {
                        title: 'Compassionate Care',
                        description: 'We treat every customer with kindness, respect, and genuine concern for their health and well-being.'
                    },
                    {
                        title: 'Excellence',
                        description: 'We maintain the highest standards in pharmaceutical care, ensuring accuracy and quality in everything we do.'
                    },
                    {
                        title: 'Community Focus',
                        description: 'We\'re committed to serving our neighborhood and building strong relationships with our customers.'
                    },
                    {
                        title: 'Expert Guidance',
                        description: 'Our licensed pharmacists provide knowledgeable advice and answer all your medication questions.'
                    },
                    {
                        title: 'Convenience',
                        description: 'Fast service, free delivery, and flexible hours to fit your busy lifestyle.'
                    },
                    {
                        title: 'Trust',
                        description: 'We earn your trust through consistent, reliable service and transparent communication.'
                    }
                ]
            },
            whyChoose: {
                title: 'Why Choose Hillside Dhaka Pharmacy?',
                subtitle: 'We go above and beyond to ensure you receive the best pharmaceutical care',
                features: [
                    'Serving the neighborhood for many years',
                    'Competitive discounts available',
                    'Free home delivery every day',
                    'Hassle-free prescription transfers',
                    'We accept most insurances',
                    'Fast prescription filling (10-15 minutes)',
                    'Walk-ins welcome, no appointment needed',
                    'Multilingual staff (English & Bengali)',
                    'Medication synchronization services',
                    'Immunizations available on-site',
                    'Free medication consultations',
                    'Personalized care and attention'
                ]
            },
            cta: {
                title: 'Visit Us Today',
                subtitle: 'Experience the difference of personalized pharmacy care',
                contactUs: 'Contact Us'
            }
        },
        services: {
            hero: {
                title: 'Our',
                titleHighlight: 'Services',
                subtitle: 'Comprehensive pharmacy services designed to keep you and your family healthy'
            },
            serviceCards: [
                {
                    title: 'Prescriptions & Medications',
                    features: [
                        'Fast prescription filling (10-15 min)',
                        'Hassle-free transfers',
                        'Medication synchronization',
                        'Automatic refill reminders',
                        'Prior authorization assistance',
                        'Special medication orders'
                    ],
                    learnMore: 'Learn more'
                },
                {
                    title: 'Immunizations & Vaccines',
                    features: [
                        'Flu shots',
                        'COVID-19 vaccines',
                        'RSV vaccine',
                        'Shingles (Shingrix)',
                        'Pneumonia vaccines',
                        'Travel vaccines'
                    ],
                    learnMore: 'Learn more'
                },
                {
                    title: 'Clinical Services',
                    features: [
                        'Blood pressure monitoring',
                        'Diabetes counseling',
                        'Glucose monitoring',
                        'Free medication consultations',
                        'Health screenings',
                        'Medication therapy management'
                    ],
                    learnMore: 'Learn more'
                },
                {
                    title: 'Specialty Services',
                    features: [
                        'DME supplies',
                        'Blister packaging',
                        'Pill organizers',
                        'Workers\' compensation support',
                        'Special orders',
                        'OTC recommendations'
                    ],
                    learnMore: 'Learn more'
                }
            ],
            additional: {
                title: 'Additional Services',
                subtitle: 'Even more ways we can help you',
                items: [
                    {
                        title: 'Free Delivery',
                        desc: 'Home delivery at no extra cost'
                    },
                    {
                        title: 'Multilingual Staff',
                        desc: 'English & Bengali speaking'
                    },
                    {
                        title: 'Competitive Pricing',
                        desc: 'Best prices & discount programs'
                    },
                    {
                        title: 'Insurance Accepted',
                        desc: 'Medicaid, Medicare & most plans'
                    }
                ]
            },
            cta: {
                title: 'Ready to Experience Better Pharmacy Care?',
                subtitle: 'Visit us or call today',
                contactUs: 'Contact Us'
            }
        },
        contact: {
            hero: {
                title: 'Contact',
                titleHighlight: 'Us',
                subtitle: "We're here to help! Reach out with any questions about our services"
            },
            form: {
                title: 'Send Us a Message',
                nameLabel: 'Full Name',
                emailLabel: 'Email Address',
                phoneLabel: 'Phone Number',
                messageLabel: 'Message',
                namePlaceholder: 'John Doe',
                emailPlaceholder: 'john@example.com',
                phonePlaceholder: '(718) 526-2300',
                messagePlaceholder: 'How can we help you?',
                submitButton: 'Send Message'
            },
            assistance: {
                title: 'Need Immediate Assistance?',
                subtitle: 'Call us directly or send an email',
                phone: 'Phone',
                email: 'Email',
                address: 'Address',
                storeHours: 'Store Hours'
            }
        },
        resources: {
            hero: {
                title: 'Health Tips &',
                titleHighlight: 'Resources',
                subtitle: 'Helpful information to keep you and your family healthy'
            },
            medicationSafety: {
                title: 'Medication Safety Tips',
                sections: [
                    {
                        title: 'Take as Directed',
                        tips: [
                            'Follow your doctor\'s and pharmacist\'s instructions exactly',
                            'Don\'t skip doses or stop early',
                            'Set reminders to take medications on time',
                            'Ask questions if you\'re unsure about anything'
                        ]
                    },
                    {
                        title: 'Store Properly',
                        tips: [
                            'Keep medications in their original containers',
                            'Store in a cool, dry place away from moisture',
                            'Keep out of reach of children and pets',
                            'Check expiration dates regularly'
                        ]
                    },
                    {
                        title: 'Avoid Interactions',
                        tips: [
                            'Tell your pharmacist about ALL medications you take',
                            'Include vitamins and supplements',
                            'Ask about food and drink interactions',
                            'Check before taking new medications'
                        ]
                    },
                    {
                        title: 'Know Your Medications',
                        tips: [
                            'Understand what each medication is for',
                            'Know potential side effects',
                            'Be aware of warning signs',
                            'Keep an updated medication list'
                        ]
                    }
                ]
            },
            seasonalHealth: {
                title: 'Seasonal Health Tips',
                seasons: [
                    {
                        season: 'Fall/Winter',
                        tips: [
                            'Get your flu shot early',
                            'Wash hands frequently',
                            'Stay hydrated',
                            'Get enough rest',
                            'Update vaccinations'
                        ]
                    },
                    {
                        season: 'Spring',
                        tips: [
                            'Manage allergies proactively',
                            'Maintain outdoor activities',
                            'Review medication needs',
                            'Spring cleaning safety',
                            'Allergy medication ready'
                        ]
                    },
                    {
                        season: 'Summer',
                        tips: [
                            'Use sunscreen daily',
                            'Stay hydrated in heat',
                            'Protect medications from heat',
                            'Travel medication planning',
                            'Insect bite prevention'
                        ]
                    }
                ]
            },
            commonConditions: {
                title: 'Managing Common Conditions',
                conditions: [
                    {
                        condition: 'Diabetes',
                        tips: 'Monitor blood sugar, take medications as directed, maintain healthy diet, exercise regularly'
                    },
                    {
                        condition: 'High Blood Pressure',
                        tips: 'Regular monitoring, low-sodium diet, stress management, consistent medication'
                    },
                    {
                        condition: 'Asthma',
                        tips: 'Avoid triggers, use inhaler correctly, track symptoms, keep rescue inhaler handy'
                    },
                    {
                        condition: 'Allergies',
                        tips: 'Identify triggers, preventive medications, keep windows closed, wash bedding weekly'
                    },
                    {
                        condition: 'Arthritis',
                        tips: 'Stay active, manage weight, use hot/cold therapy, take medications regularly'
                    },
                    {
                        condition: 'Cholesterol',
                        tips: 'Heart-healthy diet, regular exercise, medication compliance, regular check-ups'
                    }
                ]
            },
            cta: {
                title: 'Have Health Questions?',
                subtitle: 'Our licensed pharmacists are here to help with free consultations',
                callUs: 'Call Us: 718-526-2300'
            }
        },
        prescriptions: {
            hero: {
                title: 'Prescription',
                titleHighlight: 'Services',
                subtitle: 'Fast, accurate prescription filling with personalized service. Most prescriptions ready in 10-15 minutes.'
            },
            services: [
                {
                    title: 'Fast Prescription Filling',
                    description: 'Most prescriptions ready in 10-15 minutes. Walk-ins welcome, no appointment necessary. Our team works quickly without compromising accuracy.'
                },
                {
                    title: 'Hassle-Free Transfers',
                    description: 'We handle the entire prescription transfer process. Just provide your information and we\'ll contact your previous pharmacy to transfer all your medications.'
                },
                {
                    title: 'Medication Synchronization',
                    description: 'Sync all your medications to refill on the same day each month. One trip, all your meds — making your life easier.'
                },
                {
                    title: 'Automatic Refill Reminders',
                    description: 'Never run out of your medications. We\'ll remind you when it\'s time to refill and can have them ready when you need them.'
                },
                {
                    title: 'Prior Authorization Assistance',
                    description: 'Our team helps with prior authorization requirements, working directly with your insurance and doctor to get approvals quickly.'
                },
                {
                    title: 'Special Orders',
                    description: 'Hard-to-find medications? We accept special orders and work to get you what you need promptly.'
                }
            ],
            insurance: {
                title: '✓ We Accept Most Insurances',
                subtitle: 'We accept Medicaid, Medicare Part D, and most private insurance plans. We also offer competitive cash pricing and discount programs for those without insurance.',
                plans: ['Medicaid', 'Medicare Part D', 'Private Insurance', 'Cash Pay Options']
            },
            cta: {
                title: 'Ready to Transfer Your Prescriptions?',
                subtitle: 'We make it easy and hassle-free',
                contactUs: 'Contact Us'
            }
        },
        immunizations: {
            hero: {
                title: 'Immunizations &',
                titleHighlight: 'Vaccines',
                subtitle: 'Protect yourself and your family with our comprehensive immunization services. Walk-ins welcome!'
            },
            sectionTitle: 'Available Vaccines',
            sectionSubtitle: 'Protecting your health is our priority',
            vaccines: [
                {
                    title: 'Flu (Influenza)',
                    description: 'Annual flu vaccine for all ages 6 months and up'
                },
                {
                    title: 'COVID-19',
                    description: 'Latest COVID-19 vaccines and boosters available'
                },
                {
                    title: 'RSV',
                    description: 'Respiratory Syncytial Virus vaccine for eligible patients'
                },
                {
                    title: 'Shingles',
                    description: 'Shingrix vaccine for adults 50 and older'
                },
                {
                    title: 'Pneumonia',
                    description: 'Pneumococcal vaccines for adults and children'
                },
                {
                    title: 'Travel Vaccines',
                    description: 'Vaccines for international travel destinations'
                }
            ],
            features: [
                {
                    title: 'Walk-Ins Welcome',
                    description: 'No appointment necessary for most vaccines. Stop by during operating hours.'
                },
                {
                    title: 'Insurance Billing',
                    description: 'We bill most insurance plans directly. Most vaccines covered at no cost.'
                },
                {
                    title: 'Immunization Records',
                    description: 'We maintain detailed records and can provide documentation when needed.'
                }
            ],
            cta: {
                title: 'Get Your Vaccines Today',
                subtitle: 'Walk-ins welcome or call to schedule',
                contactUs: 'Contact Us'
            }
        },
        specialtyServices: {
            hero: {
                title: 'Specialty',
                titleHighlight: 'Services',
                subtitle: 'Specialized pharmacy services to meet your unique needs'
            },
            services: [
                {
                    title: 'DME Supplies',
                    description: 'Durable medical equipment and supplies available. Ask our team about what we have in stock.'
                },
                {
                    title: 'Blister Packaging',
                    description: 'Organize your medications with blister packs for easy daily management and compliance.'
                },
                {
                    title: 'Workers\' Compensation Support',
                    description: 'We handle workers\' comp prescriptions and coordinate with your employer.'
                },
                {
                    title: 'Special Orders',
                    description: 'Hard-to-find medications? We accept special orders to get you what you need.'
                }
            ],
            cta: {
                title: 'Need Something Special?',
                subtitle: 'Contact us about our specialty services'
            }
        },
        clinicalServices: {
            hero: {
                title: 'Clinical & Health',
                titleHighlight: 'Services',
                subtitle: 'Expert healthcare services to keep you healthy'
            },
            services: [
                {
                    title: 'Blood Pressure Monitoring',
                    description: 'Free blood pressure checks available. Track your health with regular monitoring and personalized advice.'
                },
                {
                    title: 'Diabetes Counseling',
                    description: 'Expert guidance on diabetes management, glucose monitoring, and medication therapy.'
                },
                {
                    title: 'Medication Therapy Management',
                    description: 'Comprehensive medication reviews to optimize your therapy and avoid interactions.'
                },
                {
                    title: 'Free Health Screenings',
                    description: 'Various health screenings available to help detect and prevent health issues early.'
                }
            ],
            cta: {
                title: 'Schedule a Consultation',
                subtitle: 'Talk to our licensed pharmacists'
            }
        },
        footer: {
            tagline: 'Your local community pharmacy serving the Jamaica, NY neighborhood for many years. Fast prescriptions, free delivery, and personalized care.',
            quickLinks: {
                title: 'Quick Links',
                // Careers section
                careers: {
                    hero: {
                        title: 'Careers',
                        titleHighlight: '',
                        subtitle: 'Join our team and make a difference in the community.'
                    },
                    description: 'We are always looking for passionate individuals to join our team.',
                    contactUs: 'Contact Us'
                },
            },
            ourServices: {
                title: 'Our Services',
                prescriptions: 'Prescriptions',
                immunizations: 'Immunizations',
                clinical: 'Clinical Services',
                specialty: 'Specialty Services'
            },
            address: '170-14 Hillside Avenue',
            city: 'Jamaica, NY 11432',
            hours: {
                weekdays: 'Mon-Sat: 10.00 am - 7.00 pm',
                sunday: 'Sun: Closed'
            },
            delivery: 'Free Home Delivery'
        },
        careers: {
            hero: {
                title: 'Careers',
                titleHighlight: '',
                subtitle: 'Join our team at Hillside Dhaka Pharmacy'
            },
            about: {
                title: 'Why Work With Us?',
                subtitle: 'Be part of a healthcare team that makes a real difference in Jamaica, NY',
                description: 'At Hillside Dhaka Pharmacy, we\'re more than just a pharmacy – we\'re a healthcare family dedicated to serving our community with compassion, expertise, and personalized care.'
            },
            benefits: {
                title: 'Benefits & Perks',
                items: [
                    'Competitive salary and benefits package',
                    'Health, dental, and vision insurance',
                    'Paid time off and holidays',
                    'Professional development opportunities',
                    'Flexible scheduling options',
                    'Employee discounts on prescriptions and products',
                    'Supportive team environment',
                    'Career advancement opportunities'
                ]
            },
            positions: {
                title: 'Current Openings',
                subtitle: 'Join our growing team of healthcare professionals',
                items: [
                    {
                        title: 'Pharmacist',
                        type: 'Full-Time',
                        description: 'Licensed pharmacist responsible for dispensing medications, providing patient counseling, and ensuring quality pharmaceutical care.'
                    },
                    {
                        title: 'Pharmacy Technician',
                        type: 'Full-Time/Part-Time',
                        description: 'Assist pharmacists in preparing and dispensing medications, managing inventory, and providing excellent customer service.'
                    },
                    {
                        title: 'Customer Service Representative',
                        type: 'Part-Time',
                        description: 'Front desk position handling customer inquiries, prescription drop-offs, and providing friendly service to our patients.'
                    },
                    {
                        title: 'Delivery Driver',
                        type: 'Part-Time',
                        description: 'Responsible for timely and safe delivery of prescriptions and medical supplies to our community members.'
                    }
                ]
            },
            culture: {
                title: 'Our Culture',
                subtitle: 'A workplace where you can grow and make a difference',
                values: [
                    {
                        title: 'Community First',
                        description: 'We prioritize the health and well-being of our Jamaica, NY community above all else.'
                    },
                    {
                        title: 'Excellence in Care',
                        description: 'We maintain the highest standards of pharmaceutical care and customer service.'
                    },
                    {
                        title: 'Team Collaboration',
                        description: 'We work together to provide the best possible outcomes for our patients.'
                    },
                    {
                        title: 'Continuous Learning',
                        description: 'We encourage ongoing education and professional development for all team members.'
                    }
                ]
            },
            description: 'Explore opportunities to work with us and make a difference in the community.',
            contactUs: 'Contact Us',
            applyNow: 'Apply Now'
        }
    },
    bn: {
        home: {
            hero: {
                badge: 'বহু বছর ধরে পাড়ায় সেবা প্রদান',
                title: 'আপনার স্থানীয়',
                titleHighlight: 'ফার্মেসি',
                subtitle: 'দ্রুত, বন্ধুত্বপূর্ণ এবং নির্ভরযোগ্য সেবা। বিনামূল্যে হোম ডেলিভারি, বিশেষজ্ঞ ঔষধ পরামর্শ এবং জ্যামাইকা, এনওয়াই এ আমাদের সম্প্রদায়ের জন্য ব্যক্তিগত যত্ন।',
                ctaContact: 'যোগাযোগ করুন',
                ctaServices: 'আমাদের সেবা'
            },
            trustBar: {
                prescriptionTime: '১০-১৫ মিনিট',
                prescriptionLabel: 'প্রেসক্রিপশন প্রস্তুত',
                deliveryLabel: 'বিনামূল্যে',
                deliverySubLabel: 'হোম ডেলিভারি',
                staffLabel: 'বহুভাষিক',
                staffSubLabel: 'কর্মীরা উপলব্ধ',
                insuranceLabel: 'অধিকাংশ',
                insuranceSubLabel: 'বীমা গৃহীত'
            },
            services: {
                title: 'আমাদের সেবা',
                subtitle: 'আপনাকে সুস্থ এবং সুস্বাস্থ্য রাখার জন্য ডিজাইন করা বিস্তৃত ফার্মেসি সেবা।',
                viewAll: 'সমস্ত সেবা দেখুন',
                cards: [
                    {
                        title: 'প্রেসক্রিপশন',
                        body: 'দ্রুত প্রেসক্রিপশন পূরণ, ঝামেলামুক্ত স্থানান্তর, ওষুধ সিঙ্ক্রোনাইজেশন এবং স্বয়ংক্রিয় রিফিল রিমাইন্ডার।',
                        learnMore: 'আরও জানুন'
                    },
                    {
                        title: 'টিকাকরণ',
                        body: 'ফ্লু, কোভিড-১৯, আরএসভি, শিংলস, নিউমোনিয়া ভ্যাকসিন এবং আরও অনেক কিছু। ওয়াক-ইন স্বাগত বা অ্যাপয়েন্টমেন্ট নিন।',
                        learnMore: 'আরও জানুন'
                    },
                    {
                        title: 'ক্লিনিক্যাল সেবা',
                        body: 'রক্তচাপ পরীক্ষা, ডায়াবেটিস পরামর্শ, গ্লুকোজ মনিটরিং, বিনামূল্যে ওষুধ পরামর্শ।',
                        learnMore: 'আরও জানুন'
                    },
                    {
                        title: 'বিশেষায়িত সেবা',
                        body: 'ডিএমই সরবরাহ, শ্রমিক ক্ষতিপূরণ সহায়তা, ব্লিস্টার প্যাকেজিং এবং বিশেষ ওষুধ অর্ডার।',
                        learnMore: 'আরও জানুন'
                    }
                ]
            },
            whyChoose: {
                title: 'কেন হিলসাইড ঢাকা ফার্মেসি বেছে নেবেন',
                subtitle: 'আমরা শুধু একটি ফার্মেসি নই — আমরা সম্প্রদায়ে আপনার স্বাস্থ্যসেবা অংশীদার।',
                features: [
                    {
                        title: 'বিনামূল্যে হোম ডেলিভারি',
                        description: 'আপনার ওষুধ বিনা খরচে আপনার দোরগোড়ায় পৌঁছে দিন। প্রতিদিন ডেলিভারি পরিষেবা উপলব্ধ।'
                    },
                    {
                        title: 'দ্রুত সেবা',
                        description: '১০-১৫ মিনিটে বেশিরভাগ প্রেসক্রিপশন প্রস্তুত। ওয়াক-ইন স্বাগত, কোন অ্যাপয়েন্টমেন্ট প্রয়োজন নেই।'
                    },
                    {
                        title: 'বহুভাষিক কর্মী',
                        description: 'আমাদের দল আমাদের বৈচিত্র্যময় সম্প্রদায়কে আরও ভালভাবে পরিবেশন করতে ইংরেজি এবং বাংলা বলে।'
                    },
                    {
                        title: 'প্রতিযোগিতামূলক মূল্য',
                        description: 'প্রতিযোগিতামূলক নগদ মূল্য এবং ছাড় প্রোগ্রাম। আমরা মেডিকেড, মেডিকেয়ার এবং বেশিরভাগ বীমা গ্রহণ করি।'
                    },
                    {
                        title: 'বিশেষজ্ঞ পরামর্শ',
                        description: 'লাইসেন্সপ্রাপ্ত ফার্মাসিস্ট বিনামূল্যে ওষুধ পরামর্শ এবং ওটিসি সুপারিশের জন্য উপলব্ধ।'
                    },
                    {
                        title: 'সম্প্রদায় কেন্দ্রীভূত',
                        description: 'বহু বছর ধরে ব্যক্তিগত যত্ন সহ বাঙালি পাড়ায় সেবা প্রদানকারী পরিবার-মালিকানাধীন ফার্মেসি।'
                    }
                ]
            },
            cta: {
                title: 'আজই আমাদের পরিদর্শন করুন',
                getDirections: 'দিকনির্দেশনা পান',
                contactUs: 'যোগাযোগ করুন'
            }
        },
        about: {
            hero: {
                title: 'আমাদের',
                titleHighlight: 'সম্পর্কে',
                subtitle: 'আপনার বিশ্বস্ত পাড়ার ফার্মেসি, যত্ন এবং নিষ্ঠার সাথে জ্যামাইকা সম্প্রদায়কে সেবা প্রদান করছে'
            },
            story: {
                title: 'আমাদের গল্প',
                paragraphs: [
                    'হিলসাইড ঢাকা ফার্মেসি গর্বের সাথে বহু বছর ধরে জ্যামাইকা, এনওয়াই সম্প্রদায়ের সেবা করে আসছে। ১৭০১৪ হিলসাইড এভিনিউতে অবস্থিত, আমরা আপনার স্থানীয়, পরিবার-মালিকানাধীন ফার্মেসি যা ব্যতিক্রমী ফার্মাসিউটিক্যাল যত্ন এবং ব্যক্তিগত সেবা প্রদানের জন্য নিবেদিত।',
                    'বাঙালি পাড়ার কেন্দ্রে একটি সম্প্রদায় ফার্মেসি হিসাবে, আমরা আমাদের বৈচিত্র্যময় সম্প্রদায়ের অনন্য স্বাস্থ্যসেবা চাহিদা বুঝি। আমাদের বহুভাষিক কর্মীরা ইংরেজি এবং বাংলায় আপনাকে সহায়তা করতে এখানে আছেন, যা আপনার স্বাস্থ্যসেবা চাহিদার স্পষ্ট যোগাযোগ এবং বোঝাপড়া নিশ্চিত করে।',
                    'আমরা আমাদের গ্রাহকদের সাথে স্থায়ী সম্পর্ক তৈরিতে বিশ্বাস করি। যখন আপনি আমাদের দরজা দিয়ে প্রবেশ করেন, আপনি শুধু একটি প্রেসক্রিপশন নম্বর নন—আপনি আমাদের ফার্মেসি পরিবারের একজন মূল্যবান সদস্য।'
                ]
            },
            values: {
                title: 'আমাদের মূল্যবোধ',
                subtitle: 'প্রতিদিন আমাদের চালিত করে যা',
                items: [
                    {
                        title: 'সহানুভূতিশীল যত্ন',
                        description: 'আমরা প্রতিটি গ্রাহককে তাদের স্বাস্থ্য এবং সুস্থতার জন্য দয়া, সম্মান এবং আন্তরিক উদ্বেগের সাথে আচরণ করি।'
                    },
                    {
                        title: 'শ্রেষ্ঠত্ব',
                        description: 'আমরা ফার্মাসিউটিক্যাল যত্নে সর্বোচ্চ মান বজায় রাখি, আমরা যা করি তার সবকিছুতে নির্ভুলতা এবং মান নিশ্চিত করি।'
                    },
                    {
                        title: 'সম্প্রদায় ফোকাস',
                        description: 'আমরা আমাদের পাড়ায় সেবা করতে এবং আমাদের গ্রাহকদের সাথে দৃঢ় সম্পর্ক তৈরি করতে প্রতিশ্রুতিবদ্ধ।'
                    },
                    {
                        title: 'বিশেষজ্ঞ নির্দেশনা',
                        description: 'আমাদের লাইসেন্সপ্রাপ্ত ফার্মাসিস্টরা জ্ঞানপূর্ণ পরামর্শ প্রদান করে এবং আপনার ওষুধের সমস্ত প্রশ্নের উত্তর দেয়।'
                    },
                    {
                        title: 'সুবিধা',
                        description: 'দ্রুত সেবা, বিনামূল্যে ডেলিভারি এবং আপনার ব্যস্ত জীবনধারার সাথে মানানসই নমনীয় সময়।'
                    },
                    {
                        title: 'বিশ্বাস',
                        description: 'আমরা ধারাবাহিক, নির্ভরযোগ্য সেবা এবং স্বচ্ছ যোগাযোগের মাধ্যমে আপনার বিশ্বাস অর্জন করি।'
                    }
                ]
            },
            whyChoose: {
                title: 'কেন হিলসাইড ঢাকা ফার্মেসি বেছে নেবেন?',
                subtitle: 'আমরা নিশ্চিত করতে আরও এগিয়ে যাই যে আপনি সর্বোত্তম ফার্মাসিউটিক্যাল যত্ন পান',
                features: [
                    'বহু বছর ধরে পাড়ায় সেবা প্রদান',
                    'প্রতিযোগিতামূলক ছাড় উপলব্ধ',
                    'প্রতিদিন বিনামূল্যে হোম ডেলিভারি',
                    'ঝামেলামুক্ত প্রেসক্রিপশন স্থানান্তর',
                    'আমরা অধিকাংশ বীমা গ্রহণ করি',
                    'দ্রুত প্রেসক্রিপশন পূরণ (১০-১৫ মিনিট)',
                    'ওয়াক-ইন স্বাগত, কোন অ্যাপয়েন্টমেন্ট প্রয়োজন নেই',
                    'বহুভাষিক কর্মী (ইংরেজি এবং বাংলা)',
                    'ওষুধ সিঙ্ক্রোনাইজেশন পরিষেবা',
                    'সাইটে টিকা উপলব্ধ',
                    'বিনামূল্যে ওষুধ পরামর্শ',
                    'ব্যক্তিগত যত্ন এবং মনোযোগ'
                ]
            },
            cta: {
                title: 'আজই আমাদের পরিদর্শন করুন',
                subtitle: 'ব্যক্তিগত ফার্মেসি যত্নের পার্থক্য অনুভব করুন',
                contactUs: 'যোগাযোগ করুন'
            }
        },
        services: {
            hero: {
                title: 'আমাদের',
                titleHighlight: 'সেবা',
                subtitle: 'আপনাকে এবং আপনার পরিবারকে সুস্থ রাখার জন্য ডিজাইন করা বিস্তৃত ফার্মেসি সেবা'
            },
            serviceCards: [
                {
                    title: 'প্রেসক্রিপশন এবং ওষুধ',
                    features: [
                        'দ্রুত প্রেসক্রিপশন পূরণ (১০-১৫ মিনিট)',
                        'ঝামেলামুক্ত স্থানান্তর',
                        'ওষুধ সিঙ্ক্রোনাইজেশন',
                        'স্বয়ংক্রিয় রিফিল রিমাইন্ডার',
                        'পূর্ব অনুমোদন সহায়তা',
                        'বিশেষ ওষুধ অর্ডার'
                    ],
                    learnMore: 'আরও জানুন'
                },
                {
                    title: 'টিকাকরণ এবং ভ্যা্কসিন',
                    features: [
                        'ফ্লু শট',
                        'কোভিড-১৯ ভ্যাকসিন',
                        'আরএসভি ভ্যাকসিন',
                        'শিংলস (শিংগ্রিক্স)',
                        'নিউমোনিয়া ভ্যাকসিন',
                        'ভ্রমণ ভ্যাকসিন'
                    ],
                    learnMore: 'আরও জানুন'
                },
                {
                    title: 'ক্লিনিক্যাল সেবা',
                    features: [
                        'রক্তচাপ মনিটরিং',
                        'ডায়াবেটিস পরামর্শ',
                        'গ্লুকোজ মনিটরিং',
                        'বিনামূল্যে ওষুধ পরামর্শ',
                        'স্বাস্থ্য স্ক্রীনিং',
                        'ওষুধ থেরাপি ম্যানেজমেন্ট'
                    ],
                    learnMore: 'আরও জানুন'
                },
                {
                    title: 'বিশেষায়িত সেবা',
                    features: [
                        'ডিএমই সরবরাহ',
                        'ব্লিস্টার প্যাকেজিং',
                        'পিল অর্গানাইজার',
                        'শ্রমিক ক্ষতিপূরণ সহায়তা',
                        'বিশেষ অর্ডার',
                        'ওটিসি সুপারিশ'
                    ],
                    learnMore: 'আরও জানুন'
                }
            ],
            additional: {
                title: 'অতিরিক্ত সেবা',
                subtitle: 'আমরা আপনাকে সাহায্য করতে পারি আরও অনেক উপায়ে',
                items: [
                    {
                        title: 'বিনামূল্যে ডেলিভারি',
                        desc: 'বিনা খরচে হোম ডেলিভারি'
                    },
                    {
                        title: 'বহুভাষিক কর্মী',
                        desc: 'ইংরেজি এবং বাংলা ভাষী'
                    },
                    {
                        title: 'প্রতিযোগিতামূলক মূল্য',
                        desc: 'সেরা মূল্য এবং ছাড় প্রোগ্রাম'
                    },
                    {
                        title: 'বীমা গৃহীত',
                        desc: 'মেডিকেড, মেডিকেয়ার এবং অধিকাংশ পরিকল্পনা'
                    }
                ]
            },
            cta: {
                title: 'আরও ভাল ফার্মেসি যত্ন অনুভব করতে প্রস্তুত?',
                subtitle: 'আজই আমাদের পরিদর্শন করুন বা কল করুন',
                contactUs: 'যোগাযোগ করুন'
            }
        },
        resources: {
            hero: {
                title: 'স্বাস্থ্য টিপস এবং',
                titleHighlight: 'সম্পদ',
                subtitle: 'আপনাকে এবং আপনার পরিবারকে সুস্থ রাখতে সহায়ক তথ্য'
            },
            medicationSafety: {
                title: 'ওষুধ সুরক্ষা টিপস',
                sections: [
                    {
                        title: 'নির্দেশ অনুযায়ী নিন',
                        tips: [
                            'আপনার ডাক্তার এবং ফার্মাসিস্টের নির্দেশাবলী ঠি্কভাবে অনুসরণ করুন',
                            'ডোজ এড়িয়ে যাবেন না বা তাড়াতাড়ি বন্ধ করবেন না',
                            'সময়মতো ওষুধ খাওয়ার জন্য রিমাইন্ডার সেট করুন',
                            'আপনি কোনো কিছু নিশ্চিত না হলে প্রশ্ন করুন'
                        ]
                    },
                    {
                        title: 'সঠিকভাবে সংরক্ষণ করুন',
                        tips: [
                            'ওষুধ তাদের মূল পাত্রে রাখুন',
                            'আর্দ্রতা থেকে দূরে ঠান্ডা, শুষ্ক জায়গায় সংরক্ষণ করুন',
                            'শিশুদের এবং পোষা প্রাণীদের নাগালের বাইরে রাখুন',
                            'নিয়মিত মেয়াদ শেষের তারিখ পরীক্ষা করুন'
                        ]
                    },
                    {
                        title: 'মিথস্ক্রিয়া এড়িয়ে চলুন',
                        tips: [
                            'আপনার ফার্মাসিস্টকে আপনি নিয়ে থাকা সমস্ত ওষুধ সম্পর্কে বলুন',
                            'ভিটামিন এবং সম্পূরক অন্তর্ভুক্ত করুন',
                            'খাদ্য এবং পানীয় মিথস্ক্রিয়া সম্পর্কে জিজ্ঞাসা করুন',
                            'নতুন ওষুধ নেওয়ার আগে পরীক্ষা করুন'
                        ]
                    },
                    {
                        title: 'আপনার ওষুধ জানুন',
                        tips: [
                            'প্রতিটি ওষুধ কী জন্য তা বুঝুন',
                            'সম্ভাব্য পার্শ্ব প্রতিক্রিয়া জানুন',
                            'সতর্কতা চিহ্ন সম্পর্কে সচেতন থাকুন',
                            'একটি আপডেট ওষুধ তালিকা রাখুন'
                        ]
                    }
                ]
            },
            seasonalHealth: {
                title: 'ঋতুভিত্তিক স্বাস্থ্য টিপস',
                seasons: [
                    {
                        season: 'শরৎ/শীত',
                        tips: [
                            'তাড়াতাড়ি আপনার ফ্লু শট নিন',
                            'ঘন ঘন হাত ধোয়া',
                            'হাইড্রেটেড থাকুন',
                            'পর্যাপ্ত বিশ্রাম নিন',
                            'টিকা আপডেট করুন'
                        ]
                    },
                    {
                        season: 'বসন্ত',
                        tips: [
                            'সক্রিয়ভাবে অ্যালার্জি পরিচালনা করুন',
                            'বাইরের কার্যক্রম বজায় রাখুন',
                            'ওষুধের প্রয়োজনীয়তা পর্যালোচনা করুন',
                            'বসন্ত পরিষ্কার নিরাপত্তা',
                            'অ্যালার্জির ওষুধ প্রস্তুত'
                        ]
                    },
                    {
                        season: 'গ্রীষ্ম',
                        tips: [
                            'প্রতিদিন সানস্ক্রিন ব্যবহার করুন',
                            'গরমে হাইড্রেটেড থাকুন',
                            'তাপ থেকে ওষুধ রক্ষা করুন',
                            'ভ্রমণ ওষুধ পরিকল্পনা',
                            'পোকামাকড়ের কামড় প্রতিরোধ'
                        ]
                    }
                ]
            },
            commonConditions: {
                title: 'সাধারণ অবস্থার ব্যবস্থাপনা',
                conditions: [
                    {
                        condition: 'ডায়াবেটিস',
                        tips: 'রক্তে শর্করা পর্যবেক্ষণ করুন, নির্দেশ অনুযায়ী ওষুধ নিন, স্বাস্থ্যকর খাদ্য বজায় রাখুন, নিয়মিত ব্যায়াম করুন'
                    },
                    {
                        condition: 'উচ্চ রক্তচাপ',
                        tips: 'নিয়মিত পর্যবেক্ষণ, কম সোডিয়াম খাদ্য, চাপ ব্যবস্থাপনা, সামঞ্জস্যপূর্ণ ওষুধ'
                    },
                    {
                        condition: 'হাঁপানি',
                        tips: 'ট্রিগার এড়িয়ে চলুন, সঠিকভাবে ইনহেলার ব্যবহার করুন, লক্ষণ ট্র্যাক করুন, উদ্ধার ইনহেলার হাতে রাখুন'
                    },
                    {
                        condition: 'অ্যালার্জি',
                        tips: 'ট্রিগার চিহ্নিত করুন, প্রতিরোধমূলক ওষুধ, জানালা বন্ধ রাখুন, সাপ্তাহিক বিছানার চাদর ধোয়া'
                    },
                    {
                        condition: 'আর্থ্রাইটিস',
                        tips: 'সক্রিয় থাকুন, ওজন নিয়ন্ত্রণ করুন, গরম/ঠান্ডা থেরাপি ব্যবহার করুন, নিয়মিত ওষুধ নিন'
                    },
                    {
                        condition: 'কোলেস্টেরল',
                        tips: 'স্বাস্থ্যকর খাদ্য, নিয়মিত ব্যায়াম, ওষুধ মেনে চলা, নিয়মিত পরীক্ষা'
                    }
                ]
            },
            cta: {
                title: 'স্বাস্থ্য প্রশ্ন আছে?',
                subtitle: 'আমাদের লাইসেন্সপ্রাপ্ত ফার্মাসিস্টরা বিনামূল্যে পরামর্শের জন্য এখানে আছেন',
                callUs: 'কল করুন: 718-526-2300'
            }
        },
        prescriptions: {
            hero: {
                title: 'প্রেসক্রিপশন',
                titleHighlight: 'সেবা',
                subtitle: 'দ্রুত, নির্ভুল প্রেসক্রিপশন পূরণ ব্যক্তিগত সেবা সহ। বেশিরভাগ প্রেসক্রিপশন ১০-১৫ মিনিটে প্রস্তুত।'
            },
            services: [
                {
                    title: 'দ্রুত প্রেসক্রিপশন পূরণ',
                    description: 'বেশিরভাগ প্রেসক্রিপশন ১০-১৫ মিনিটে প্রস্তুত। ওয়াক-ইন স্বাগত, কোন অ্যাপয়েন্টমেন্ট প্রয়োজন নেই। আমাদের দল দ্রুত কাজ করে নির্ভুলতা ছাড়া নয়।'
                },
                {
                    title: 'ঝামেলামুক্ত স্থানান্তর',
                    description: 'আমরা সম্পূর্ণ প্রেসক্রিপশন স্থানান্তর প্রক্রিয়া পরিচালনা করি। শুধু আপনার তথ্য দিন এবং আমরা আপনার আগের ফার্মেসির সাথে যোগাযোগ করে আপনার সমস্ত ওষুধ স্থানান্তর করব।'
                },
                {
                    title: 'ওষুধ সিঙ্ক্রোনাইজেশন',
                    description: 'আপনার সমস্ত ওষুধ প্রতি মাসে একই দিনে রিফিল করার জন্য সিঙ্ক করুন। এক ট্রিপ, আপনার সমস্ত ওষুধ — আপনার জীবন সহজ করে তোলে।'
                },
                {
                    title: 'স্বয়ংক্রিয় রিফিল রিমাইন্ডার',
                    description: 'আপনি কখনও আপনার ওষুধ শেষ করবেন না। আমরা আপনাকে রিফিলের সময় মনে করিয়ে দেব এবং আপনার প্রয়োজনের সময় তাদের প্রস্তুত রাখতে পারি।'
                },
                {
                    title: 'পূর্ব অনুমোদন সহায়তা',
                    description: 'আমাদের দল পূর্ব অনুমোদনের প্রয়োজনীয়তাগুলিতে সাহায্য করে, আপনার বীমা এবং ডাক্তারের সাথে সরাসরি কাজ করে দ্রুত অনুমোদন পেতে।'
                },
                {
                    title: 'বিশেষ অর্ডার',
                    description: 'খুঁজে পাওয়া কঠিন ওষুধ? আমরা বিশেষ অর্ডার গ্রহণ করি এবং আপনার প্রয়োজনীয় জিনিস দ্রুত পেতে কাজ করি।'
                }
            ],
            insurance: {
                title: '✓ আমরা অধিকাংশ বীমা গ্রহণ করি',
                subtitle: 'আমরা মেডিকেড, মেডিকেয়ার পার্ট ডি, এবং বেশিরভাগ ব্যক্তিগত বীমা পরিকল্পনা গ্রহণ করি। আমরা বীমা ছাড়া লোকদের জন্য প্রতিযোগিতামূলক নগদ মূল্য এবং ছাড় প্রোগ্রামও অফার করি।',
                plans: ['মেডিকেড', 'মেডিকেয়ার পার্ট ডি', 'ব্যক্তিগত বীমা', 'নগদ পেমেন্ট অপশন']
            },
            cta: {
                title: 'আপনার প্রেসক্রিপশন স্থানান্তর করতে প্রস্তুত?',
                subtitle: 'আমরা এটি সহজ এবং ঝামেলামুক্ত করে তুলি',
                contactUs: 'যোগাযোগ করুন'
            }
        },
        immunizations: {
            hero: {
                title: 'টিকাকরণ এবং',
                titleHighlight: 'ভ্যাকসিন',
                subtitle: 'আমাদের বিস্তৃত টিকাকরণ সেবা দিয়ে নিজেকে এবং আপনার পরিবারকে রক্ষা করুন। ওয়াক-ইন স্বাগত!'
            },
            sectionTitle: 'উপলব্ধ ভ্যাকসিন',
            sectionSubtitle: 'আপনার স্বাস্থ্য রক্ষা করা আমাদের অগ্রাধিকার',
            vaccines: [
                {
                    title: 'ফ্লু (ইনফ্লুয়েঞ্জা)',
                    description: '৬ মাস এবং তার বেশি বয়সের সকলের জন্য বার্ষিক ফ্লু ভ্যাকসিন'
                },
                {
                    title: 'কোভিড-১৯',
                    description: 'সর্বশেষ কোভিড-১৯ ভ্যাকসিন এবং বুস্টার উপলব্ধ'
                },
                {
                    title: 'আরএসভি',
                    description: 'যোগ্য রোগীদের জন্য শ্বাসযন্ত্রের সিনসিটিয়াল ভাইরাস ভ্যাকসিন'
                },
                {
                    title: 'শিংলস',
                    description: '৫০ বছর বা তার বেশি বয়সের প্রাপ্তবয়স্কদের জন্য শিংগ্রিক্স ভ্যাকসিন'
                },
                {
                    title: 'নিউমোনিয়া',
                    description: 'প্রাপ্তবয়স্ক এবং শিশুদের জন্য নিউমোকক্কাল ভ্যাকসিন'
                },
                {
                    title: 'ভ্রমণ ভ্যাকসিন',
                    description: 'আন্তর্জাতিক ভ্রমণ গন্তব্যের জন্য ভ্যাকসিন'
                }
            ],
            features: [
                {
                    title: 'ওয়াক-ইন স্বাগত',
                    description: 'বেশিরভাগ ভ্যাকসিনের জন্য কোন অ্যাপয়েন্টমেন্ট প্রয়োজন নেই। অপারেটিং সময়ের মধ্যে আসুন।'
                },
                {
                    title: 'বীমা বিলিং',
                    description: 'আমরা সরাসরি অধিকাংশ বীমা পরিকল্পনা বিল করি। বেশিরভাগ ভ্যাকসিন বিনা খরচে কভার করা হয়।'
                },
                {
                    title: 'টিকাকরণ রেকর্ড',
                    description: 'আমরা বিস্তারিত রেকর্ড বজায় রাখি এবং প্রয়োজনে ডকুমেন্টেশন প্রদান করতে পারি।'
                }
            ],
            cta: {
                title: 'আজই আপনার ভ্যাকসিন নিন',
                subtitle: 'ওয়াক-ইন স্বাগত বা সময় নির্ধারণ করতে কল করুন',
                contactUs: 'যোগাযোগ করুন'
            }
        },
        specialtyServices: {
            hero: {
                title: 'বিশেষায়িত',
                titleHighlight: 'সেবা',
                subtitle: 'আপনার অনন্য চাহিদা পূরণের জন্য বিশেষায়িত ফার্মেসি সেবা'
            },
            services: [
                {
                    title: 'ডিএমই সরবরাহ',
                    description: 'টেকসই চিকিৎসা সরঞ্জাম এবং সরবরাহ উপলব্ধ। স্টকে কী আছে সে সম্পর্কে আমাদের দলকে জিজ্ঞাসা করুন।'
                },
                {
                    title: 'ব্লিস্টার প্যাকেজিং',
                    description: 'সহজ দৈনিক ব্যবস্থাপনা এবং সম্মতির জন্য ব্লিস্টার প্যাক দিয়ে আপনার ওষুধ সংগঠিত করুন।'
                },
                {
                    title: 'শ্রমিক ক্ষতিপূরণ সহায়তা',
                    description: 'আমরা শ্রমিক ক্ষতিপূরণ প্রেসক্রিপশন পরিচালনা করি এবং আপনার নিয়োগকর্তার সাথে সমন্বয় করি।'
                },
                {
                    title: 'বিশেষ অর্ডার',
                    description: 'খুঁজে পাওয়া কঠিন ওষুধ? আমরা আপনার প্রয়োজনীয় জিনিস পেতে বিশেষ অর্ডার গ্রহণ করি।'
                }
            ],
            cta: {
                title: 'কিছু বিশেষ প্রয়োজন?',
                subtitle: 'আমাদের বিশেষায়িত সেবা সম্পর্কে আমাদের সাথে যোগাযোগ করুন'
            }
        },
        clinicalServices: {
            hero: {
                title: 'ক্লিনিক্যাল ও স্বাস্থ্য',
                titleHighlight: 'সেবা',
                subtitle: 'আপনাকে সুস্থ রাখতে বিশেষজ্ঞ স্বাস্থ্যসেবা সেবা'
            },
            services: [
                {
                    title: 'রক্তচাপ পর্যবেক্ষণ',
                    description: 'বিনামূল্যে রক্তচাপ পরীক্ষা উপলব্ধ। নিয়মিত পর্যবেক্ষণ এবং ব্যক্তিগত পরামর্শ দিয়ে আপনার স্বাস্থ্য ট্র্যাক করুন।'
                },
                {
                    title: 'ডায়াবেটিস কাউন্সেলিং',
                    description: 'ডায়াবেটিস ব্যবস্থাপনা, গ্লুকোজ পর্যবেক্ষণ এবং ওষুধ থেরাপিতে বিশেষজ্ঞ নির্দেশনা।'
                },
                {
                    title: 'ওষুধ থেরাপি ব্যবস্থাপনা',
                    description: 'আপনার থেরাপি অপ্টিমাইজ করতে এবং মিথস্ক্রিয়া এড়াতে ব্যাপক ওষুধ পর্যালোচনা।'
                },
                {
                    title: 'বিনামূল্যে স্বাস্থ্য স্ক্রিনিং',
                    description: 'স্বাস্থ্য সমস্যা প্রাথমিকভাবে সনাক্ত এবং প্রতিরোধ করতে বিভিন্ন স্বাস্থ্য স্ক্রিনিং উপলব্ধ।'
                }
            ],
            cta: {
                title: 'একটি পরামর্শ নির্ধারণ করুন',
                subtitle: 'আমাদের লাইসেন্সপ্রাপ্ত ফার্মাসিস্টদের সাথে কথা বলুন'
            }
        },
        specialtyServices: {
            hero: {
                title: 'বিশেষায়িত',
                titleHighlight: 'সেবা',
                subtitle: 'আপনার অনন্য চাহিদা পূরণের জন্য বিশেষায়িত ফার্মেসি সেবা'
            },
            services: [
                {
                    title: 'ডিএমই সরবরাহ',
                    description: 'টেকসই চিকিৎসা সরঞ্জাম এবং সরবরাহ উপলব্ধ। স্টকে কী আছে সে সম্পর্কে আমাদের দলকে জিজ্ঞাসা করুন।'
                },
                {
                    title: 'ব্লিস্টার প্যাকেজিং',
                    description: 'সহজ দৈনিক ব্যবস্থাপনা এবং সম্মতির জন্য ব্লিস্টার প্যাক দিয়ে আপনার ওষুধ সংগঠিত করুন।'
                },
                {
                    title: 'শ্রমিক ক্ষতিপূরণ সহায়তা',
                    description: 'আমরা শ্রমিক ক্ষতিপূরণ প্রেসক্রিপশন পরিচালনা করি এবং আপনার নিয়োগকর্তার সাথে সমন্বয় করি।'
                },
                {
                    title: 'বিশেষ অর্ডার',
                    description: 'খুঁজে পাওয়া কঠিন ওষুধ? আমরা আপনার প্রয়োজনীয় জিনিস পেতে বিশেষ অর্ডার গ্রহণ করি।'
                }
            ],
            cta: {
                title: 'কিছু বিশেষ প্রয়োজন?',
                subtitle: 'আমাদের বিশেষায়িত সেবা সম্পর্কে আমাদের সাথে যোগাযোগ করুন'
            }
        },
        clinicalServices: {
            hero: {
                title: 'ক্লিনিক্যাল ও স্বাস্থ্য',
                titleHighlight: 'সেবা',
                subtitle: 'আপনাকে সুস্থ রাখতে বিশেষজ্ঞ স্বাস্থ্যসেবা সেবা'
            },
            services: [
                {
                    title: 'রক্তচাপ পর্যবেক্ষণ',
                    description: 'বিনামূল্যে রক্তচাপ পরীক্ষা উপলব্ধ। নিয়মিত পর্যবেক্ষণ এবং ব্যক্তিগত পরামর্শ দিয়ে আপনার স্বাস্থ্য ট্র্যাক করুন।'
                },
                {
                    title: 'ডায়াবেটিস কাউন্সেলিং',
                    description: 'ডায়াবেটিস ব্যবস্থাপনা, গ্লুকোজ পর্যবেক্ষণ এবং ওষুধ থেরাপিতে বিশেষজ্ঞ নির্দেশনা।'
                },
                {
                    title: 'ওষুধ থেরাপি ব্যবস্থাপনা',
                    description: 'আপনার থেরাপি অপ্টিমাইজ করতে এবং মিথস্ক্রিয়া এড়াতে ব্যাপক ওষুধ পর্যালোচনা।'
                },
                {
                    title: 'বিনামূল্যে স্বাস্থ্য স্ক্রিনিং',
                    description: 'স্বাস্থ্য সমস্যা প্রাথমিকভাবে সনাক্ত এবং প্রতিরোধ করতে বিভিন্ন স্বাস্থ্য স্ক্রিনিং উপলব্ধ।'
                }
            ],
            cta: {
                title: 'একটি পরামর্শ নির্ধারণ করুন',
                subtitle: 'আমাদের লাইসেন্সপ্রাপ্ত ফার্মাসিস্টদের সাথে কথা বলুন'
            }
        },
        contact: {
            hero: {
                title: 'যোগাযোগ',
                titleHighlight: 'করুন',
                subtitle: 'আমরা আপনাকে সাহায্য করতে এখানে আছি! আমাদের পরিষেবা সম্পর্কে যেকোনো প্রশ্নের জন্য যোগাযোগ করুন'
            },
            form: {
                title: 'আমাদের একটি বার্তা পাঠান',
                nameLabel: 'পূর্ণ নাম',
                emailLabel: 'ইমেইল ঠিকানা',
                phoneLabel: 'ফোন নম্বর',
                messageLabel: 'বার্তা',
                namePlaceholder: 'আপনার নাম',
                emailPlaceholder: 'your@email.com',
                phonePlaceholder: '(718) 526-2300',
                messagePlaceholder: 'আমরা কিভাবে আপনাকে সাহায্য করতে পারি?',
                submitButton: 'বার্তা পাঠান'
            },
            assistance: {
                title: 'জরুরী সহায়তা প্রয়োজন?',
                subtitle: 'আমাদের সরাসরি কল করুন বা একটি ইমেল পাঠান',
                phone: 'ফোন',
                email: 'ইমেইল',
                address: 'ঠিকানা',
                storeHours: 'দোকান খোলার সময়'
            }
        },
        footer: {
            tagline: 'বহু বছর ধরে জ্যামাইকা, এনওয়াই এলাকায় সেবা প্রদানকারী আপনার স্থানীয় কমিউনিটি ফার্মেসি। দ্রুত প্রেসক্রিপশন, বিনামূল্যে ডেলিভারি এবং ব্যক্তিগত যত্ন।',
            quickLinks: {
                title: 'দ্রুত লিঙ্ক',
                home: 'হোম',
                about: 'আমাদের সম্পর্কে',
                services: 'সেবাসমূহ',
                healthTips: 'স্বাস্থ্য টিপস',
                contact: 'যোগাযোগ'
            },
            ourServices: {
                title: 'আমাদের সেবা',
                prescriptions: 'প্রেসক্রিপশন',
                immunizations: 'টিকাকরণ',
                clinical: 'ক্লিনিক্যাল সেবা',
                specialty: 'বিশেষায়িত সেবা'
            },
            address: '১৭০-১৪ হিলসাইড এভিনিউ',
            city: 'জ্যামাইকা, এনওয়াই ১১৪৩২',
            hours: {
                weekdays: 'সোম-শনি: সকাল ১০টা - সন্ধ্যা ৭টা',
                sunday: 'রবি: বন্ধ'
            },
            delivery: 'বিনামূল্যে হোম ডেলিভারি'
        },
        careers: {
            hero: {
                title: 'ক্যারিয়ার',
                titleHighlight: '',
                subtitle: 'হিলসাইড ঢাকা ফার্মেসিতে আমাদের দলে যোগ দিন'
            },
            about: {
                title: 'আমাদের সাথে কেন কাজ করবেন?',
                subtitle: 'জ্যামাইকা, এনওয়াই তে আসল পার্থক্য তৈরি করে এমন একটি স্বাস্থ্যসেবা দলের অংশ হন',
                description: 'হিলসাইড ঢাকা ফার্মেসিতে, আমরা শুধু একটি ফার্মেসি নই - আমরা একটি স্বাস্থ্যসেবা পরিবার যা সহানুভূতি, দক্ষতা এবং ব্যক্তিগত যত্নের সাথে আমাদের সম্প্রদায়কে সেবা দেওয়ার প্রতিশ্রুতিবদ্ধ।'
            },
            benefits: {
                title: 'সুবিধা ও সুযোগ',
                items: [
                    'প্রতিযোগিতামূলক বেতন এবং সুবিধা প্যাকেজ',
                    'স্বাস্থ্য, দন্ত এবং চক্ষু বীমা',
                    'অর্জিত সময় এবং ছুটির দিন',
                    'পেশাদার উন্নয়নের সুযোগ',
                    'নমনীয় সময়সূচী বিকল্প',
                    'প্রেসক্রিপশন এবং পণ্যগুলিতে কর্মচারী ছাড়',
                    'সহায়ক দলের পরিবেশ',
                    'ক্যারিয়ার অগ্রগতির সুযোগ'
                ]
            },
            positions: {
                title: 'বর্তমান শূন্যপদ',
                subtitle: 'আমাদের ক্রমবর্ধমান স্বাস্থ্যসেবা পেশাদারদের দলে যোগ দিন',
                items: [
                    {
                        title: 'ফার্মাসিস্ট',
                        type: 'পূর্ণ-সময়',
                        description: 'ওষুধ সরবরাহ, রোগী পরামর্শ প্রদান এবং গুণমান ফার্মাসিউটিকাল যত্ন নিশ্চিত করার জন্য দায়িত্বপ্রাপ্ত লাইসেন্সপ্রাপ্ত ফার্মাসিস্ট।'
                    },
                    {
                        title: 'ফার্মেসি টেকনিশিয়ান',
                        type: 'পূর্ণ-সময়/অংশ-সময়',
                        description: 'ওষুধ প্রস্তুত এবং সরবরাহে ফার্মাসিস্টদের সহায়তা করুন, ইনভেন্টরি পরিচালনা করুন এবং চমৎকার গ্রাহক পরিষেবা প্রদান করুন।'
                    },
                    {
                        title: 'গ্রাহক পরিষেবা প্রতিনিধি',
                        type: 'অংশ-সময়',
                        description: 'গ্রাহক অনুসন্ধান, প্রেসক্রিপশন ড্রপ-অফ পরিচালনা এবং আমাদের রোগীদের বন্ধুত্বপূর্ণ পরিষেবা প্রদানের জন্য সামনের ডেস্ক পজিশন।'
                    },
                    {
                        title: 'ডেলিভারি ড্রাইভার',
                        type: 'অংশ-সময়',
                        description: 'আমাদের সম্প্রদায়ের সদস্যদের কাছে প্রেসক্রিপশন এবং চিকিৎসা সরবরাহের সময়োপযোগী এবং নিরাপদ ডেলিভারির জন্য দায়িত্বপ্রাপ্ত।'
                    }
                ]
            },
            culture: {
                title: 'আমাদের সংস্কৃতি',
                subtitle: 'একটি কর্মক্ষেত্র যেখানে আপনি বাড়তে পারেন এবং পার্থক্য তৈরি করতে পারেন',
                values: [
                    {
                        title: 'সম্প্রদায় প্রথম',
                        description: 'আমরা আমাদের জ্যামাইকা, এনওয়াই সম্প্রদায়ের স্বাস্থ্য এবং কল্যাণকে সবচেয়ে বেশি অগ্রাধিকার দিই।'
                    },
                    {
                        title: 'যত্নে উৎকর্ষ',
                        description: 'আমরা ফার্মাসিউটিকাল যত্ন এবং গ্রাহক পরিষেবার সর্বোচ্চ মান বজায় রাখি।'
                    },
                    {
                        title: 'দল সহযোগিতা',
                        description: 'আমরা আমাদের রোগীদের জন্য সেরা সম্ভাব্য ফলাফল প্রদানের জন্য একসাথে কাজ করি।'
                    },
                    {
                        title: 'অবিরাম শেখা',
                        description: 'আমরা সমস্ত দলের সদস্যদের জন্য চলমান শিক্ষা এবং পেশাদার উন্নয়নকে উৎসাহিত করি।'
                    }
                ]
            },
            description: 'আমাদের সাথে কাজ করার সুযোগ অন্বেষণ করুন এবং সম্প্রদায়ে পার্থক্য তৈরি করুন।',
            contactUs: 'যোগাযোগ করুন',
            applyNow: 'আবেদন করুন'
        }
    }
};
